import { ReactNode } from "react";
import Navigation from "@components/Navigation";
import "./LegalPage.scss";

export interface LegalSection {
  heading: string;
  body: ReactNode;
}

interface Props {
  title: string;
  updated: string;
  intro: string;
  sections: LegalSection[];
}

export default function LegalPage({ title, updated, intro, sections }: Props) {
  return (
    <div className="lp-root legal-page">
      <Navigation />
      <main className="legal-main">
        <div className="legal-container">
          <a href="/" className="legal-back">
            ← Back to home
          </a>
          <h1 className="legal-title">{title}</h1>
          <p className="legal-updated">Last updated: {updated}</p>
          <p className="legal-intro">{intro}</p>

          {sections.map((s) => (
            <section className="legal-section" key={s.heading}>
              <h2>{s.heading}</h2>
              {s.body}
            </section>
          ))}

          <p className="legal-contact">
            Questions about this page? Email us at{" "}
            <a href="mailto:info@oculera.health">info@oculera.health</a>.
          </p>
        </div>
      </main>

      <footer className="legal-footer">
        <p>© {new Date().getFullYear()} Oculera. All rights reserved.</p>
      </footer>
    </div>
  );
}
